import { Option } from "@inrev/core";
import { FC } from "react";
import { formatEmpty } from "../../../../../../utils";

type StatBlockProps = {
	label: string;
	value: Option<string | number>;
	sub?: Option<string>;
};

export const StatBlock: FC<StatBlockProps> = ({ label, value, sub }) => {
	return (
		<div className="flex flex-col gap-1 rounded-lg border border-bc-default bg-surface-base p-3">
			<div className="text-tertiary text-[11px] font-medium uppercase tracking-wide">{label}</div>
			<div className="text-[18px] font-semibold text-primary">{formatEmpty(value)}</div>
			{sub && <div className="text-tertiary text-[12px]">{sub}</div>}
		</div>
	);
};
